/** Stable logical identities for Marketplace Intelligence owned fixed UDO templates. */
export enum MarketplaceIntelligenceWorkspaceCapabilityUdoTemplateKey {
    settings = "69a23992-d6aa-43d9-9aa8-9f2d1e021c01",
    mapping = "69a23992-d6aa-43d9-9aa8-9f2d1e021c02",
    syncRun = "69a23992-d6aa-43d9-9aa8-9f2d1e021c03",
    priceSnapshot = "69a23992-d6aa-43d9-9aa8-9f2d1e021c04",
}
